module.exports = __webpack_public_path__ + "static/media/cnito-sizzle-es.71d2577c.mp4";